/**
 * Envío AP-9 · qué es distinto entre lo que se ve en el editor y lo guardado
 * en el servidor, en palabras: para decidir «Recargar» o «Mantener lo mío»
 * sin adivinar.
 */
const TRACKS = [
  ['videoClips', 'Video'], ['imageClips', 'Imagen'], ['overlayV1Clips', 'Superposición 1'],
  ['overlayV2Clips', 'Superposición 2'], ['audioClips', 'Audio'],
];
const CLIP_FIELDS = [
  ['start_time', 'inicio'], ['duration', 'duración'], ['trim_start', 'recorte'],
  ['source_url', 'archivo'], ['transform', 'posición o tamaño'], ['volume', 'volumen'],
  ['muted', 'silencio'], ['fade_in', 'fundido'], ['fade_out', 'fundido'], ['edit', 'edición de imagen'],
];
const ELEMENT_FIELDS = [
  ['start', 'inicio'], ['duration', 'duración'], ['content', 'texto'], ['style', 'estilo'],
  ['transform', 'posición o tamaño'], ['visible', 'visibilidad'], ['source_url', 'archivo'],
];

const same = (a, b) => {
  if (typeof a === 'number' && typeof b === 'number') return Math.abs(a - b) < 0.01;
  return JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
};

function compare(list, mine, theirs, where, fields, idKey, labelOf) {
  const a = new Map((mine || []).map((x) => [x[idKey], x]));
  const b = new Map((theirs || []).map((x) => [x[idKey], x]));
  for (const [id, x] of a) {
    const y = b.get(id);
    if (!y) { list.push({ label: labelOf(x), where, change: 'solo_aca' }); continue; }
    const what = [...new Set(fields.filter(([k]) => !same(x[k], y[k])).map(([, w]) => w))];
    if (what.length) list.push({ label: labelOf(x), where, change: 'distinto', what });
  }
  for (const [id, y] of b) {
    if (!a.has(id)) list.push({ label: labelOf(y), where, change: 'solo_servidor' });
  }
}

/** Lista de diferencias (vacía si son iguales). */
export function diffTimelines(local, remote) {
  const out = [];
  for (const [key, where] of TRACKS) {
    compare(out, local?.[key], remote?.[key], where, CLIP_FIELDS, 'id', (c) => c.label || 'Clip');
  }
  compare(out, local?.elements, remote?.elements, 'Texto o sticker', ELEMENT_FIELDS, 'element_id',
    (e) => (e.type === 'text' ? (e.content || e.label || 'Texto').split('\n')[0] : e.label || 'Sticker').slice(0, 40));
  return out;
}

export function describeDiff(d) {
  if (d.change === 'solo_aca') return 'sólo en tu pantalla';
  if (d.change === 'solo_servidor') return 'sólo en lo guardado';
  return `distinto: ${d.what.join(', ')}`;
}
